export function AdminPageLayout({
  eyebrow,
  title,
  description,
  actions,
  children,
}) {
  return (
    <div className="admin-page">
      <section className="admin-page-hero">
        <div className="admin-page-hero__content">
          {eyebrow ? <span className="admin-page-hero__eyebrow">{eyebrow}</span> : null}
          <h1 className="admin-page-hero__title">{title}</h1>
          {description ? <p className="admin-page-hero__description">{description}</p> : null}
        </div>
        {actions ? <div className="admin-page-hero__actions">{actions}</div> : null}
      </section>
      <div className="admin-page__content">{children}</div>
    </div>
  );
}

export function AdminSectionCard({ title, description, actions, children, className = "" }) {
  return (
    <section className={`admin-surface ${className}`.trim()}>
      {title || description || actions ? (
        <div className="admin-surface__header">
          <div>
            {title ? <h2 className="admin-surface__title">{title}</h2> : null}
            {description ? <p className="admin-surface__description">{description}</p> : null}
          </div>
          {actions ? <div className="admin-surface__actions">{actions}</div> : null}
        </div>
      ) : null}
      <div>{children}</div>
    </section>
  );
}
